<template>
    <v-container class="white--text copyright pa-0">
        <v-layout>
            <div>
                BISTRO CAFÉ HARFA &copy; 2020
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'Copyright'
    }
</script>

<style lang="scss">
    .copyright {
        font-size: 12px;
    }
</style>
